import Vue from 'vue';

import './style/quasar.styl';
import 'quasar/dist/quasar.ie.polyfills';
import lang from 'quasar/lang/zh-hans.js';
import '@quasar/extras/material-icons/material-icons.css';
import {
  Quasar,
  QLayout,
  QHeader,
  QDrawer,
  QPageContainer,
  QPage,
  QToolbar,
  QToolbarTitle,
  QBtn,
  QIcon,
  QList,
  QItem,
  QItemSection,
  QItemLabel,
  QDialog,
  ClosePopup,
  QForm,
  QInput,
  Dialog,
  QDate,
  QCarousel,
  QCarouselControl,
  QCarouselSlide,
  TouchSwipe,
  TouchPan,
  QSelect,
} from 'quasar';

Vue.use(Quasar, {
  config: {},
  components: {
    QLayout,
    QHeader,
    QDrawer,
    QPageContainer,
    QPage,
    QToolbar,
    QToolbarTitle,
    QBtn,
    QIcon,
    QList,
    QItem,
    QItemSection,
    QItemLabel,
    QDialog,
    QForm,
    QInput,
    QDate,
    QCarousel,
    QCarouselControl,
    QCarouselSlide,
    QSelect,
  },
  directives: {
    ClosePopup,
    TouchSwipe,
    TouchPan,
  },
  plugins: {
    Dialog,
  },
  lang,
 });
